<!--  -->
<template>
  <div>
    <!-- <el-button type="success" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="video/*" @change="uploadPictures"></el-button> -->
    <div class="videolist">
      <div v-for="item,index in arr" :key="index" class="videoitem" :class="[item.show ? 'videoitemactive' : '']" @click="choosetew(item)">
        <video
          width="200"
          height="200"
          controls
          muted
          :src="item.videosrc"
        />
      </div>
    </div>
    <el-button type="primary" class="determine" @click="detercilck">确定</el-button>
  </div>
</template>

<script>
// import { newMaterial } from '@/api/sourceMaterial.js'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
export default {
  components: {},
  data() {
    return {
      arr: [
        {
          videosrc: 'https://ziyuan.jingxuansz.com/user/tr00es--666666.mp4',
          show: false
        },
        {
          videosrc: 'https://ziyuan.jingxuansz.com/user/tr00es--666666.mp4',
          show: false
        }
      ],
      obj: null,
      num: null
    }
  },
  created() {
    this.getQiniuToken()
  },
  mounted() {

  },
  methods: {
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    async uploadPictures(e) {
      const fileIfon = e.target.files[0]
      console.log('fileIfon', fileIfon)
      const name = fileIfon.name
      // const img = new Image()
      // const temporary = window.URL.createObjectURL(fileIfon)
      // img.src = temporary
      // this.temporary = temporary
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          console.log('data', data, name)
          // setTimeout(async() => {
          //   await newMaterial({
          //     type: 1,
          //     size: fileIfon.size,
          //     key: data.key
          //   })
          //   await this.getlist()
          //   this.temporary = null
          // }, 500)
        }

      })
    },
    choosetew(item) {
      this.arr.forEach(item => {
        item.show = false
      })
      item.show = true
      this.obj = item
    },
    detercilck() {
      if (this.obj === null) {
        this.$message.error('请选择视频')
        return
      }
      this.obj.num = this.num
      console.log(this.obj)
      this.$emit('callvideo', this.obj)
      this.obj = null
    },
    send(num) {
      this.num = num
      console.log('num', num)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.videolist{
  display: flex;
  align-items: center;
}
.videoitem{
  margin-right: 20px;
}
.videoitemactive{
  border: 2px solid #07c160;
}
.determine{
  margin-top: 50px;
}
</style>
